import { createGlobalStyle } from 'styled-components'

const BaselineStyles = createGlobalStyle`
  * {
    padding: 0;
    margin: 0;
  }

  a {
    text-decoration: none;
    color: inherit;
  }
`

export default BaselineStyles
